import { authRoutes } from '~/utils/routes/auth';

export const publicRoutes = [...authRoutes];
